import { render } from "./BalBtnGroup.vue?vue&type=template&id=36fe3e83"
import script from "./BalBtnGroup.vue?vue&type=script&lang=ts"
export * from "./BalBtnGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script